import type {
  RuleListApiData,
  RuleListApiResponses,
  RuleSetCreateApiData,
  RuleSetCreateApiResponses,
  RuleSetDeleteApiData,
  RuleSetDeleteApiResponses,
  RuleSetGetApiData,
  RuleSetGetApiResponses,
  RuleSetListApiData,
  RuleSetListApiResponses,
  RuleSetPatchApiData,
  RuleSetPatchApiResponses,
  RuleValidationMetadataApiData,
  RuleValidationMetadataApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getRuleSetUrls = {
  getPaginatedRuleSets: dataEndpoint<RuleSetListApiData, RuleSetListApiResponses>({
    getUrl: (queryParams) => apiUrl('rule-sets/', queryParams)
  }),
  getRuleSet: dataEndpoint<RuleSetGetApiData, RuleSetGetApiResponses>({
    getUrl: ({ ruleSetId }) => apiUrl(`rule-sets/${ruleSetId}/`)
  }),
  postCreateRuleSet: responseEndpoint<RuleSetCreateApiData, RuleSetCreateApiResponses>({
    getUrl: () => apiUrl('rule-sets/'),
    getBody: (data) => data
  }),
  patchRuleSet: responseEndpoint<RuleSetPatchApiData, RuleSetPatchApiResponses>({
    getUrl: ({ ruleSetId }) => apiUrl(`rule-sets/${ruleSetId}/`),
    getBody: ({ ruleSetId: _, ...body }) => body
  }),
  deleteRuleSet: dataEndpoint<RuleSetDeleteApiData, RuleSetDeleteApiResponses>({
    getUrl: ({ ruleSetId }) => apiUrl(`rule-sets/${ruleSetId}/`)
  }),
  getPaginatedRules: dataEndpoint<RuleListApiData, RuleListApiResponses>({
    getUrl: (queryParams) => apiUrl('rules/', queryParams)
  }),
  getRuleValidationMetadata: dataEndpoint<RuleValidationMetadataApiData, RuleValidationMetadataApiResponses>({
    getUrl: () => apiUrl('rules/validation-metadata/')
  })
};
